// extracted by mini-css-extract-plugin
export default {"userListAssignSec":"UserList_userListAssignSec__N+OKK","userListAssignH6":"UserList_userListAssignH6__Uz0IO","userListContentSec":"UserList_userListContentSec__Q0ImE"};